<template>
    <div id="classdetailstu">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back"><i class="icon-fanhui"></i></span>
                <em>{{name}}（{{score}}分）</em>
            </div>
        </div>
        <template v-if="loading">
            <div class="wrap"
                 v-if="questions.length">
                <div class="tip">共{{ num }}题( 答对<span>{{num - wrongNum}}</span>题, 答错<span>{{wrongNum}}</span>题 )
                </div>
                <div class="exercises"
                     v-for="(data,index) in questions">
                    <div class="quest_title">
                        <span class="tit_num"
                              v-if="data.number">{{data.number}}、</span>
                        <p class="title"><span v-html="data.rd_titledry"></span></p>
                        <div class="img-wrap"><img :src="data.image"
                                 v-if="data.image && data.image.url" /></div>
                        <div class="judgeicon"
                             :class="[data.user_result == '1'? 'dui' : 'cuo']"></div>
                    </div>
                    <div class="quest_con">
                        <!-- 选择题 -->
                        <div>
                            <div class="check_choose">
                                <div :class="[indexText[i]==data.rd_trueoption?'choose_opation active clearfix':'choose_opation clearfix']"
                                     v-for="(item,i) in data.rd_options">
                                    <i class="option"
                                       v-html='indexText[i]'></i>
                                    <span style="background: transparent;"
                                          v-html='item'></span>
                                    <p class="choose_img_pic"
                                       v-if="item.image">
                                        <img :src="item.image"
                                             alt="">
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="answer-wrap">
                            <div class="user">
                                <div class="user-answer">他的答案:</div>
                                <div>{{data.user_answer}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <div v-cloak>
                    没有作业数据
                </div>
            </div>
            <div class="bottom_btn">
                <div @click="reward">奖励和评语</div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
import choice from 'VIEWS/chinese/module/result_choose.vue'  //选择题
import blanks from 'VIEWS/chinese/module/result_fill.vue'  //填空题
import lines from 'VIEWS/chinese/module/result_line.vue';     //连线题
import sentence from 'VIEWS/chinese/module/result_sentence.vue';//断句题
import makes from 'VIEWS/chinese/module/result_make.vue';//排序题
export default {
    data () {
        return {
            questions: [],
            testData: [],
            qids: "",
            taskid: this.$route.params.taskid,
            user_id: this.$route.params.user_id,
            name: this.$route.params.username,
            classId: this.$route.params.classid,
            reid: this.$route.query.reid,
            score: this.$route.query.score,
            loading: false,
            num: null,
            wrongNum: 0,
            indexText: ["A", "B", "C", "D"],
        }
    },
    computed: {},
    methods: {
        back () {
            this.$router.go(-1)
        },
        toComment () {
            this.$router.push('/sx/task/classdetail/commentstu/' + this.name + '/' + this.user_id)
        },
        toRemind () {
            this.$router.push('/sx/task/classdetail/remindstu/' + this.name + '/' + this.user_id)
        },
        reward () {
            this.$router.push("/tea/perreward/51/" + this.taskid + "/" + this.user_id + "?score=" + this.score + "&name=" + this.name);
        }
    },
    created () {
        this.$http.post(API_URL_TASK_API + '/chinese/check/user/task/reading', {
            "message_id": this.taskid,
            "user_id": this.user_id,
            "re_id": this.reid,
        }).then(res => {
            if (res.data.response == 'ok') {
                this.loading = true;
                if (res.data.response == 'ok') {
                    this.questions = res.data.data.question;
                    this.num = this.questions.length;
                    this.questions.forEach(d => {
                        if (d.user_result === 0) {
                            this.wrongNum++
                        }
                    });
                }
            }
        })
    },
    components: {
        loadingS,
        headers,
        sentence,
        choice,
        blanks,
        lines,
        makes
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

[v-cloak] {
    display: none;
}

#classdetailstu {
    min-height: 100vh;
}

.wrap {
    padding-bottom: 96px / $ppr;
}
.header {
    background: #5e89ef;
    .left {
        display: block;
        width: 18px / $ppr;
        height: 34px / $ppr;
        background: url("../img/choose_back.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
}

.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: $c-fbg;
    padding: 0 $w;
    margin-bottom: $w;
    span {
        color: #ff6600;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}
.answer-wrap {
    padding: $w $w;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
    .user {
        color: #999;
        font-size: 30px / $ppr;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        margin-right: 36px / $ppr;
        .user-answer {
            padding: 6px / $ppr 8px / $ppr;
            margin-right: $w;
        }
    }
}

.quest_title {
    padding: 24px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
    @include displayFlex();
    .tit_num {
        width: 48px / $ppr;
    }
    div {
        @include flex();
    }
}

.quest_con {
    position: relative;
    margin-bottom: 24px / $ppr;
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: 0.6rem;
    z-index: 2;
    width: 40px / $ppr;
    height: 36px / $ppr;
    //background-color: #21BF63;
}

.dui {
    background-image: url(img/icon_dui.png);
    background-size: cover;
}

.cuo {
    background-image: url(img/icon_cuo.png);
    background-size: cover;
}

.exercises {
    background-color: #fff;
    position: relative;
}

.block {
    display: block !important;
    .user-answer {
        color: #999;
        font-size: 30px / $ppr;
        padding-left: 24px / $ppr;
    }
}

.check_choose {
    .choose_opation {
        position: relative;
        padding: 32px / $ppr 24px / $ppr 32px / $ppr 96px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        &.active {
            color: #fff;
            .option {
                background: #66cc22;
            }
            span {
                color: #66cc22;
            }
        }
        .option {
            display: block;
            position: absolute;
            top: 50%;
            left: 24px / $ppr;
            margin-top: -24px / $ppr;
            width: 48px / $ppr;
            height: 48px / $ppr;
            line-height: 48px / $ppr;
            text-align: center;
            border-radius: 48px / $ppr;
            border: 1px / $ppr solid #dcdcdc;
        }
    }
}
</style>
